import { render, staticRenderFns } from "./UsherItem.vue?vue&type=template&id=b5d1bdd8&lang=pug&"
import script from "./UsherItem.vue?vue&type=script&lang=js&"
export * from "./UsherItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports